import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import CoreInput from '@material-ui/core/Input'
import Checkbox from '@material-ui/core/Checkbox'

import Content from 'components/shared/Content'
import Input from 'components/shared/Input'
import { normaliseID, normaliseIDwithZero } from 'utils/common'
import { ZONES, TYPES, STATUS, PRODUCTS, COUNTRIES, MATERIALCODES } from 'utils/constants'
import { ITank } from 'types'

const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

interface IProps {
  device: ITank
  materialCodes: any
  materialName: string,
  canSave: boolean
  onCancel: () => void
  onSave: () => void
  onInputChange: (
    prop: string
  ) => (
      evt:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => void
  onCheckboxChange: (
    prop: string
  ) => (
      evt: React.ChangeEvent<HTMLInputElement>
    ) => void
}

const EditMode = ({
  device,
  materialCodes,
  materialName,
  canSave,
  onCancel,
  onSave,
  onInputChange,
  onCheckboxChange
}: IProps): React.ReactElement => (
    <Grid container direction="column">
      <Grid item>
        <Content style={style} label="Device ID" value={normaliseID(device.deviceID)} />
      </Grid>
      {/* <Grid item>
        <Content style={style} label="Ship To" value={normaliseID(device.sh)} />
      </Grid> */}
      <Grid item>
        <Input label="Tank ID" value={normaliseID(device.tankId)} onChange={onInputChange('tankId')} />
      </Grid>
      <Grid item>
        <Input label="Ship To" value={normaliseIDwithZero(device.sh)} maxLength="10" onChange={onInputChange('sh')} />
      </Grid>
      <Grid item>
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="country">Country</InputLabel>
            <Select
              value={device.country}
              onChange={onInputChange('country')}
              input={<CoreInput name="country" id="country" />}
            >
              {COUNTRIES.map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  <Typography variant="body1">{label}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>
      <Grid item>
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="zone">Zone</InputLabel>
            <Select
              value={device.zone}
              onChange={onInputChange('zone')}
              input={<CoreInput name="zone" id="zone" />}
            >
              {/* {ZONES.map(({ key, label }) => (
              <MenuItem key={key} value={key}>
                <Typography variant="body1">{label}</Typography>
              </MenuItem>
            ))} */}

              {ZONES.filter((zone => zone.country == device.country)).map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  <Typography variant="body1">{label}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>
      <Grid item>
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="type">Status</InputLabel>
            <Select
              value={device.status}
              onChange={onInputChange('status')}
              input={<CoreInput name="type" id="type" />}
            >
              {STATUS.map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  <Typography variant="body1">{label}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>

      <Grid item>
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="product">Product</InputLabel>
            <Select
              value={device.product}
              onChange={onInputChange('product')}
              input={<CoreInput name="product" id="product" />}
            >
              {PRODUCTS.map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  <Typography variant="body1">{label}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>

      {(device.type.toString().indexOf('manifold') === -1 && device.type.toString().toUpperCase() !== 'BLEREADER') && (
        <Grid item>
          <Input label="Material#" value={device.productcode} onChange={onInputChange('productcode')}></Input>
        </Grid>)}
      {(device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && (<Grid item>
        {/* <Input label="Material#" value={device.productcode} onChange={onInputChange('productcode')} /> */}
        {/* MATERIALCODES */}
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="materialode">Material#</InputLabel>
            <Select
              value={device.productcode}
              onChange={onInputChange('productcode')}
              name="manifoldCode"
            // input={<CoreInput name="productcode" id="productcode" />}
            >
              {materialCodes.map(({ materialcode, capacity }) => (
                <MenuItem key={capacity} value={materialcode} >
                  <Typography variant="body1">{materialcode}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>
      )}

      {(device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && (<Grid item>
        <Input label="Material Name" value={materialName} name="manifoldCode" type="text" ></Input>
      </Grid>)}
      {((device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && device.productcode !== undefined) && (<Grid item>
        <Input label="Quantity" value={device.quantity !== undefined ? device.quantity : ''} name="manifoldCode" onChange={onInputChange('quantity')} ></Input>
      </Grid>)}

      {(device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && (<Grid item>
        <Input label="Pressure" value={device.pvalue !== undefined ? device.pvalue : ''} name="manifoldCode" type="label" ></Input>
      </Grid>)}

      {(device.type.toString().indexOf('manifold') === -1 && device.type.toString().toUpperCase() !== 'BLEREADER') && (<Grid item>
        <Input label="Capacity" value={device.capacity} onChange={onInputChange('capacity')}></Input>
      </Grid>)}

      <Grid item>
        <Input label="Name" value={device.name} onChange={onInputChange('name')} />
      </Grid>
      <Grid item>
        <Input label="Suburb" value={device.suburb} onChange={onInputChange('suburb')} />
      </Grid>
      <Grid item>
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="type">Type</InputLabel>
            <Select
              value={device.type}
              onChange={onInputChange('type')}
              input={<CoreInput name="type" id="type" />}
            >
              {TYPES.map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  <Typography variant="body1">{label}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>
      {/* <Grid item>
      <Input label="Customer" value={device.name} onChange={onInputChange('name')} />
    </Grid> */}
      <Grid item>
        <Input
          label="Address"
          value={device.street}
          onChange={onInputChange('street')}
        />
      </Grid>

      <Grid item style={{ display: localStorage.getItem('user_role') == "4" ? "" : "none", }}>
        <div style={{ display: device.settings != undefined ? "" : "none", }}>
          <Input
            label="Reorder Label"
            value={((device.settings) ? device.settings.reorder : '')} type="number" pattern="[0-9]*"
            onChange={onInputChange('settings')}
          />
        </div>

      </Grid>
      <div style={{ display: "none" }}>
        <Grid container alignItems="baseline" style={{ padding: '4px 0', ...style }}>
          <Grid item xs={5} style={{ display: "none" }}>
            <Typography variant="h4">EDI Setup</Typography>
          </Grid>
          <Grid item xs={7} style={{ display: "none" }}>
            <Checkbox
              onChange={onCheckboxChange('edisetup')}
              checked={device.edisetup}
            />
          </Grid>
        </Grid>
      </div>
      <Box my={2}>
        <Grid container item justify="space-evenly">
          <Grid item xs={5}>
            <Button fullWidth color="secondary" variant="contained" onClick={onCancel}>
              <Typography variant="h4" color="primary">
                Cancel
            </Typography>
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button fullWidth variant="contained" onClick={onSave} disabled={!canSave}>
              <Typography variant="h4" color="primary">
                Save
            </Typography>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  )

export default EditMode
